export default function reducer(state = {
    ac: '',
    tk: ''
}, action) {
    switch (action.type) {
        case 'LOGIN':
            return {
                ac: action.ac,
                tk: action.tk
            }

        default:
            return state
    }
}